export default __webpack_public_path__ + "static/media/piraten_waehlen.1085fd87.png";